import styled from "styled-components";

// ==================================================================
// DataTable (desktop) — .dtable canônico
// ==================================================================
// table-layout: fixed garante ZERO scroll lateral (princípio
// constitucional PharuERP). Colunas dimensionadas por col.width;
// conteúdo que excede usa ellipsis + title tooltip.
export const TableWrap = styled.div`
  border: 1px solid var(--border);
  border-radius: var(--radius-xl);
  background: var(--surface);
  overflow: hidden;
  overflow-x: clip;
`;

export const Table = styled.table`
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
  font-size: var(--text-md);
`;

export const Thead = styled.thead`
  background: var(--surface-2);
`;

export const Th = styled.th`
  text-align: ${({ $align }) => $align || "left"};
  font-family: var(--font-mono);
  font-size: var(--text-2xs);
  font-weight: 500;
  letter-spacing: var(--tracking-caps);
  text-transform: uppercase;
  color: var(--ink-4);
  padding: var(--space-3) var(--space-4);
  border-bottom: 1px solid var(--border);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const Tbody = styled.tbody``;

export const Tr = styled.tr`
  border-bottom: 1px solid var(--divider);
  ${({ $clickable }) => $clickable && "cursor: pointer;"}
  transition: background 0.12s ease;

  &:last-child {
    border-bottom: 0;
  }

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      background: ${({ $clickable }) =>
        $clickable ? "var(--surface-hover)" : "transparent"};
    }
  }
`;

export const Td = styled.td`
  text-align: ${({ $align }) => $align || "left"};
  padding: var(--space-3) var(--space-4);
  color: var(--ink-2);
  vertical-align: middle;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

// ==================================================================
// CardList (mobile) — 1 row = 1 card
// ==================================================================
export const CardListRoot = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
`;

export const Card = styled.article`
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  padding: var(--space-4);
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  ${({ $clickable }) => $clickable && "cursor: pointer;"}

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      border-color: ${({ $clickable }) =>
        $clickable ? "var(--border-strong)" : "var(--border)"};
    }
  }
`;

export const CardTopRow = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: var(--space-3);
  min-width: 0;
`;

export const CardTitle = styled.div`
  font-size: var(--text-base);
  font-weight: 600;
  color: var(--ink);
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const CardSubtitle = styled.div`
  font-size: var(--text-sm);
  color: var(--ink-3);
  margin-top: 2px;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const CardAside = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 2px;
  flex-shrink: 0;
  text-align: right;
  font-weight: 600;
  color: var(--ink);
  white-space: nowrap;
`;

export const CardBadges = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-2);
`;

export const CardMeta = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3px;
`;

export const CardMetaRow = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: var(--space-3);
  font-size: var(--text-sm);
  min-width: 0;
`;

export const CardMetaLabel = styled.span`
  font-family: var(--font-mono);
  font-size: var(--text-2xs);
  letter-spacing: var(--tracking-wide);
  text-transform: uppercase;
  color: var(--ink-4);
  flex-shrink: 0;
`;

export const CardMetaValue = styled.span`
  color: var(--ink-2);
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: right;
`;

// ==================================================================
// Empty / loading
// ==================================================================
export const EmptyWrap = styled.div`
  padding: var(--space-9) var(--space-5);
  text-align: center;
  color: var(--ink-3);
  font-size: var(--text-sm);
  border: 1px solid var(--border);
  border-radius: var(--radius-xl);
  background: var(--surface);
`;

export const SkeletonRow = styled.div`
  height: 16px;
  border-radius: var(--radius-sm);
  background: linear-gradient(
    90deg,
    var(--surface-2) 25%,
    var(--surface-3) 37%,
    var(--surface-2) 63%
  );
  background-size: 400% 100%;
  animation: skeleton-shimmer 1.4s ease infinite;

  @keyframes skeleton-shimmer {
    0% {
      background-position: 100% 50%;
    }
    100% {
      background-position: 0 50%;
    }
  }

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;
